<button mat-icon-button [color]="color" type="button" [matTooltip]="tooltip" [attr.aria-label]="tooltip" (click)="onResize()">
  <mat-icon fontSet="project-titan" [fontIcon]="fontIcon"></mat-icon>
</button>